(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (process){
// Generated by CoffeeScript 1.6.1
var Injector, Mapping, extractFunctionName, getRelativePath, requireClass,
  __hasProp = {}.hasOwnProperty;

getRelativePath = function(path) {
  if (typeof process !== "undefined" && process !== null) {
    return "" + (process.cwd()) + "/" + path;
  } else {
    return path;
  }
};

extractFunctionName = function(fn) {
  var str, tokens;
  str = fn.toString();
  tokens = /^[\s\r\n]*function[\s\r\n]*([^\(\s\r\n]*?)[\s\r\n]*\([^\)\s\r\n]*\)[\s\r\n]*\{((?:[^}]*\}?)+)\}\s*$/.exec(str);
  return tokens[1];
};

requireClass = function(path) {
  path = getRelativePath(path);
  return require(path);
};

Mapping = (function() {

  function Mapping(injector, mappingObject) {
    this.injector = injector;
    this.mappingObject = mappingObject;
    if (this.mappingObject.modulePath != null) {
      this.klass = requireClass(this.mappingObject.modulePath);
    }
    if (this.mappingObject.klass != null) {
      this.klass = this.mappingObject.klass;
    }
    if (this.klass != null) {
      this.klass.injector = this.injector;
    }
    if (this.mappingObject.value != null) {
      this.asValue(this.mappingObject.value);
    }
  }

  Mapping.prototype.isSingleton = false;

  Mapping.prototype.create = function() {
    var instance;
    instance = new this.klass;
    this.inject(instance);
    if (typeof instance.initInstance === "function") {
      instance.initInstance();
    }
    return instance;
  };

  Mapping.prototype.inject = function(instance) {
    var key, value, _ref, _results;
    if (instance.inject == null) {
      return;
    }
    _ref = instance.inject;
    _results = [];
    for (key in _ref) {
      if (!__hasProp.call(_ref, key)) continue;
      value = _ref[key];
      _results.push(instance[key] = this.injector.getInstanceOf(value));
    }
    return _results;
  };

  Mapping.prototype.get = function() {
    if (this.isSingleton) {
      return this.singleton || (this.singleton = this.create());
    } else {
      return this.create();
    }
  };

  Mapping.prototype.getClass = function() {
    return this.klass;
  };

  Mapping.prototype.asSingleton = function() {
    this.isSingleton = true;
    return this;
  };

  Mapping.prototype.as = function(newName) {
    this.injector.remap(this.mappingObject.name, newName);
    return this;
  };

  Mapping.prototype.asValue = function(value) {
    this.create = function() {
      return value;
    };
    return this;
  };

  return Mapping;

})();

Injector = (function() {

  function Injector() {
    this._mappings = {};
    this.map({
      value: this,
      name: "Injector"
    });
    this.checkReservedMappings = function(mappingObject) {
      if (((mappingObject != null ? mappingObject.name : void 0) != null) && mappingObject.name === "Injector") {
        throw new Error("Cannot create mappings called Injector because it is a reserved mapping");
      }
    };
  }

  Injector.prototype.validateObjectField = function(object, field, type) {
    if ((object[field] != null) && typeof object[field] !== type) {
      throw new Error("" + field + " should be a " + type);
    }
  };

  Injector.prototype.map = function(mappingObject) {
    var klass, modulePath, name, value, _base, _name;
    if (typeof this.checkReservedMappings === "function") {
      this.checkReservedMappings(mappingObject);
    }
    klass = mappingObject.klass, name = mappingObject.name, modulePath = mappingObject.modulePath, value = mappingObject.value;
    this.validateObjectField(mappingObject, "name", "string");
    this.validateObjectField(mappingObject, "klass", "function");
    this.validateObjectField(mappingObject, "modulePath", "string");
    if (klass != null) {
      if (mappingObject.name == null) {
        mappingObject.name = extractFunctionName(mappingObject.klass);
      }
    } else if (modulePath != null) {
      if (mappingObject.name == null) {
        mappingObject.name = extractFunctionName(requireClass(mappingObject.modulePath));
      }
    } else if (value != null) {
      if (name == null) {
        throw new Error("For value mappings you need to provide a name");
      }
    } else {
      throw new Error("You need to provide a klass or a modulePath or a value with optionally a name for a mappings");
    }
    return (_base = this._mappings)[_name = mappingObject.name] || (_base[_name] = new Mapping(this, mappingObject));
  };

  Injector.prototype.unmap = function(klassName) {
    return delete this._mappings[klassName];
  };

  Injector.prototype.remap = function(oldName, newName) {
    this._mappings[newName] = this._mappings[oldName];
    return this.unmap(oldName);
  };

  Injector.prototype._getMapping = function(klassName) {
    var map;
    map = this._mappings[klassName];
    if (map == null) {
      throw new Error("" + klassName + " not mapped in Injector");
    }
    return map;
  };

  Injector.prototype.getInstanceOf = function(mappedName) {
    return this._getMapping(mappedName).get();
  };

  Injector.prototype.getClassOf = function(klassName) {
    return this._getMapping(klassName).getClass();
  };

  Injector.prototype.destroy = function() {
    return this._mappings = {};
  };

  Injector.prototype.toString = function() {
    var replacer,
      _this = this;
    replacer = function(key, value) {
      if (value === _this) {
        return "Reference to itself";
      }
      return value;
    };
    return JSON.stringify(this._mappings, replacer);
  };

  Injector.InjectorSingleton = void 0;

  Injector.asSingleton = function() {
    return this.InjectorSingleton || (this.InjectorSingleton = new Injector());
  };

  return Injector;

})();

module.exports = Injector;

}).call(this,require('_process'))
},{"_process":2}],2:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(require,module,exports){
module.exports = {
  XS_MAX: 767,
  SM_MAX: 991,
  MD_MAX: 1199
};


},{}],4:[function(require,module,exports){
var BrowserResizer, Module, Observer;

Module = require('./module');

Observer = require('./observer');

module.exports = BrowserResizer = (function() {
  class BrowserResizer extends Module {
    initInstance() {
      $(window).on('resize', this.update.bind(this));
      return this.update();
    }

    update() {
      var current_width;
      current_width = $(window).width();
      if (current_width <= this.breakpoints.XS_MAX) {
        return this.set('size', 'xs');
      } else if ((this.breakpoints.XS_MAX < current_width && current_width <= this.breakpoints.SM_MAX)) {
        return this.set('size', 'sm');
      } else if ((this.breakpoints.SM_MAX < current_width && current_width <= this.breakpoints.MD_MAX)) {
        return this.set('size', 'md');
      } else {
        return this.set('size', 'lg');
      }
    }

  };

  BrowserResizer.include(Observer);

  BrowserResizer.prototype.inject = {
    breakpoints: 'Breakpoints'
  };

  BrowserResizer.prototype.size = 'lg';

  return BrowserResizer;

}).call(this);


},{"./module":8,"./observer":9}],5:[function(require,module,exports){
  // http://arcturo.github.io/library/coffeescript/03_classes.html
  // Extending Classes
var Module, moduleKeywords,
  indexOf = [].indexOf;

moduleKeywords = ['extended', 'included'];

Module = class Module {
  static extend(obj) {
    var key, ref, value;
    for (key in obj) {
      value = obj[key];
      if (indexOf.call(moduleKeywords, key) < 0) {
        this[key] = value;
      }
    }
    if ((ref = obj.extended) != null) {
      ref.apply(this);
    }
    return this;
  }

  static include(obj) {
    var key, ref, value;
    for (key in obj) {
      value = obj[key];
      if (indexOf.call(moduleKeywords, key) < 0) {
        // Assign properties to the prototype
        this.prototype[key] = value;
      }
    }
    if ((ref = obj.included) != null) {
      ref.apply(this);
    }
    return this;
  }

};

module.exports = Module;


},{}],6:[function(require,module,exports){
module.exports = {
  _observed_properties: {},
  set: function(property, value) {
    var callback, i, len, old_value, ref;
    if (property in this._observed_properties) {
      old_value = this[property];
      if (old_value !== value) {
        ref = this._observed_properties[property];
        for (i = 0, len = ref.length; i < len; i++) {
          callback = ref[i];
          callback(value, old_value);
        }
      }
    }
    return this[property] = value;
  },
  get: function(property) {
    return this[property];
  },
  observer_for: function(property, callback) {
    if (!(property in this._observed_properties)) {
      this._observed_properties[property] = [];
    }
    return this._observed_properties[property].push(callback);
  },
  remove_observer: function(property, callback) {
    var existing_callbacks, i, idx, len, ref, results;
    ref = this._observed_properties[property];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      existing_callbacks = ref[i];
      idx = existing_callbacks.indexOf(callback);
      if (idx > -1) {
        results.push(existing_callbacks.splice(idx, 1));
      } else {
        results.push(void 0);
      }
    }
    return results;
  }
};


},{}],7:[function(require,module,exports){
var ScrollTo;

module.exports = ScrollTo = class ScrollTo {
  scroll_on_navbar_click() {
    var _this;
    _this = this;
    return $('.nav.navbar-nav .dropdown a').on('click', function(e) {
      var target_href;
      e.stopImmediatePropagation();
      target_href = $(this).attr('href');
      if (target_href.indexOf(location.pathname) < 0 || location.pathname === "/" || location.pathname === "/en/") {
        _this.open_other_page(target_href);
      } else {
        _this.scroll_on_same_page(target_href);
      }
      return false;
    });
  }

  scroll_on_page_load() {
    var target_hash;
    target_hash = location.hash;
    location.hash = '';
    return $(window).on('load', function() {
      if (target_hash) {
        return ScrollTo.scroll_to_hash(target_hash, 800);
      }
    });
  }

  open_other_page(target_href) {
    return location.href = target_href;
  }

  scroll_on_same_page(target_href) {
    var target_hash;
    if (target_href.indexOf('#') < 0) {
      return this.scroll_to_top();
    } else {
      target_hash = target_href.split('#').pop();
      return ScrollTo.scroll_to_hash(target_hash);
    }
  }

  scroll_to_top() {
    return $.scrollTo(0, 300, {
      onAfter: function() {
        return ScrollTo.set_hash_without_scrolling('', $('body'));
      }
    });
  }

  static set_hash_without_scrolling(target_hash, target_elem) {
    target_elem.attr('id', '');
    location.hash = target_hash;
    return target_elem.attr('id', target_hash);
  }

  static scroll_to_hash(target_hash, anim_time = 300) {
    var target_elem;
    if (target_hash.indexOf('#' >= 0)) {
      target_hash = target_hash.replace('#', '');
    }
    target_elem = $(`#${target_hash}`);
    return $("html").scrollTo(target_elem, anim_time, {
      offset: -70,
      onAfter: function() {
        return ScrollTo.set_hash_without_scrolling(target_hash, target_elem);
      }
    });
  }

};


},{}],8:[function(require,module,exports){
arguments[4][5][0].apply(exports,arguments)
},{"dup":5}],9:[function(require,module,exports){
arguments[4][6][0].apply(exports,arguments)
},{"dup":6}],10:[function(require,module,exports){
var $, CoffeeSweetener, di, di_map, j, k, klass, l, len, len1, len2, name, never_called_to_require_globbed_coffeescripts, ref, ref1, ref2, scrollTo, value;

never_called_to_require_globbed_coffeescripts = function() {
  // http://stackoverflow.com/a/27672458/3418846
  return require('./lib/Breakpoints.coffee');require('./lib/BrowserResizer.coffee');require('./lib/Module.coffee');require('./lib/Observer.coffee');require('./lib/ScrollTo.coffee');
};

//###############################################################################
// Setup the Dependency Injection
//###############################################################################
CoffeeSweetener = require('../../node_modules/coffee-sweetener/lib/coffee-sweetener.js');

di = new CoffeeSweetener();

di_map = {
  klasses: ['BrowserResizer'],
  singletons: ['ScrollTo'],
  object: ['Breakpoints']
};

ref = di_map.klasses;
for (j = 0, len = ref.length; j < len; j++) {
  name = ref[j];
  klass = require(`./lib/${name}.coffee`);
  di.map({
    klass: klass,
    name: name
  });
}

ref1 = di_map.singletons;
for (k = 0, len1 = ref1.length; k < len1; k++) {
  name = ref1[k];
  klass = require(`./lib/${name}.coffee`);
  di.map({
    klass: klass,
    name: name
  }).asSingleton();
}

ref2 = di_map.object;
for (l = 0, len2 = ref2.length; l < len2; l++) {
  name = ref2[l];
  value = require(`./lib/${name}.coffee`);
  di.map({
    name: name,
    value: value
  });
}

$ = jQuery;

scrollTo = di.getInstanceOf('ScrollTo');

scrollTo.scroll_on_page_load();

$(document).ready(function() {
  var $lang_switch, check_scroll_top, lang_anchor, lang_code, lang_li, lang_url;
  scrollTo.scroll_on_navbar_click();
  //#############################################################################
  // Bootstrap nav
  //#############################################################################
  $('.dropdown a').on('click', function() {
    if (Modernizr.touch) {
      if ($(this).parent('.dropdown').hasClass('open')) {
        return location.href = $(this).attr('href');
      }
    } else {
      return location.href = $(this).attr('href');
    }
  });
  $(document).click(function(event) {
    var _opened, clickover;
    clickover = $(event.target);
    _opened = $('.navbar-collapse').hasClass('in');
    if (_opened === true && !clickover.hasClass('navbar-toggle')) {
      $('button.navbar-toggle').click();
    }
  });
  //#############################################################################
  // Image Covers
  //#############################################################################
  $('.image-cover img').each(function(i, image) {
    var parent_col, src;
    src = $(image).attr('src');
    parent_col = $(image).parents("[class*=vc_col-]");
    $(image).remove();
    return parent_col.css({
      background: `url(${src})`,
      'background-size': 'cover'
    });
  });
  //#############################################################################
  // Check Scroll Top
  //#############################################################################
  check_scroll_top = function() {
    if ($(document).scrollTop() < 100) {
      return $('body').removeClass('scrolled');
    } else {
      return $('body').addClass('scrolled');
    }
  };
  //#############################################################################
  // Language Switch
  //#############################################################################
  $lang_switch = $('.wpml-language-switch');
  lang_code = $lang_switch.data('lang');
  lang_url = $lang_switch.data('target');
  lang_anchor = $(`<a href='${lang_url}'>${lang_code}</a>`);
  lang_li = $('<li class="menu-item-wpml-language-switch"></li>').append(lang_anchor);
  $('.nav.navbar-nav').append(lang_li);
  $(document).on('scroll', check_scroll_top);
  return check_scroll_top();
});


},{"../../node_modules/coffee-sweetener/lib/coffee-sweetener.js":1,"./lib/Breakpoints.coffee":3,"./lib/BrowserResizer.coffee":4,"./lib/Module.coffee":5,"./lib/Observer.coffee":6,"./lib/ScrollTo.coffee":7}]},{},[10]);
